import streamers from '../images/streamers.jpg'

css .forms-page
	min-height:100vh
	d:flex
	fld:column
	.shape-header
		h:300px
	.forms
		flg:1
		.form-grid
			d:flex
			gap:1em
			fld@lt-md:column

		a.form-link
			bg:cool2 @hover:cool3
			p:5px
			rd:.25em
			flg:1
			d:flex
			ai:center
			h:15em
			c:cool6
			td:none
			pt:1em
			d:flex
			fld:column
			gap:.9em

			.skeleton-field
				bg:cool4
				d:block
				w:80%
				h:.75em
				rd:10px
				



tag forms-page
	<self.forms-page>
		<shape-header title="Forms" image=streamers>
		<text-block.forms title="Forms">
			<div.form-grid>
				<a.form-link href="https://docs.google.com/forms/d/1l3n3mmyCZa7Jjx0wat59Y48bjH_qyKbUsZQHKf27mys/edit?usp=drive_web" target="_blank">
					"Ideas & Suggestions"
					<div.skeleton-field> " "
					<div.skeleton-field> " "
					<div.skeleton-field> " "
					<div.skeleton-field> " "
					<div.skeleton-field> " "
					<div.skeleton-field> " "

				<a.form-link href="https://docs.google.com/forms/d/1Lxq1DMBc0xrXRi2R1GVa3t2ONf7E_01p4C0rkCni2AM/edit?usp=drive_web" target="_blank">
					"Information Request"
					<div.skeleton-field> " "
					<div.skeleton-field> " "
					<div.skeleton-field> " "
					<div.skeleton-field> " "
					<div.skeleton-field> " "
					<div.skeleton-field> " "

		<footer-section>